import { z } from 'zod'

import { isTransactChainId } from '~/utils'

// Strict validation: only supported chains (for wallets, vaults, swaps on supported chains)
export const chainIdSchema = z
  .number()
  .refine((chainId) => isTransactChainId(chainId), {
    message: 'Invalid chain id',
  })
